import { render, staticRenderFns } from "./curso-finalizado.vue?vue&type=template&id=037c3ba9&scoped=true&"
import script from "./curso-finalizado.vue?vue&type=script&lang=ts&"
export * from "./curso-finalizado.vue?vue&type=script&lang=ts&"
import style0 from "./curso-finalizado.vue?vue&type=style&index=0&id=037c3ba9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037c3ba9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VProgressCircular,VRow})
